import React, { useState } from 'react';
import { mockLogs } from '../data/mockData';
import { Search, Filter, Calendar, Download } from 'lucide-react';
export const AuditTrail: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const filteredLogs = mockLogs.filter(log => log.user.toLowerCase().includes(searchTerm.toLowerCase()) || log.action.toLowerCase().includes(searchTerm.toLowerCase()) || log.item.toLowerCase().includes(searchTerm.toLowerCase()));
  return <div className="max-w-7xl mx-auto" data-id="element-290">
      <div className="flex justify-between items-end mb-6" data-id="element-291">
        <div data-id="element-292">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-293">Audit Trail</h1>
          <p className="text-slate-500" data-id="element-294">
            System-wide activity log for compliance and tracking
          </p>
        </div>
        <button className="btn-secondary flex items-center text-sm" data-id="element-295">
          <Download size={16} className="mr-2" data-id="element-296" /> Export CSV
        </button>
      </div>

      <div className="card overflow-hidden" data-id="element-297">
        <div className="p-4 border-b border-slate-200 bg-slate-50 flex flex-wrap gap-4 items-center justify-between" data-id="element-298">
          <div className="relative flex-1 min-w-[300px]" data-id="element-299">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" size={18} data-id="element-300" />
            <input type="text" placeholder="Search by user, action, or item ID..." className="input-field pl-10 text-sm" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-301" />
          </div>
          <div className="flex space-x-3" data-id="element-302">
            <select className="input-field py-2 text-sm w-40" data-id="element-303">
              <option value="" data-id="element-304">All Roles</option>
              <option value="operator" data-id="element-305">Operator</option>
              <option value="officer" data-id="element-306">Officer</option>
              <option value="admin" data-id="element-307">Admin</option>
            </select>
            <button className="btn-secondary flex items-center text-sm px-3" data-id="element-308">
              <Calendar size={16} className="mr-2" data-id="element-309" /> Date Range
            </button>
          </div>
        </div>

        <div className="overflow-x-auto" data-id="element-310">
          <table className="min-w-full divide-y divide-slate-200" data-id="element-311">
            <thead className="bg-slate-50" data-id="element-312">
              <tr data-id="element-313">
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-314">
                  Timestamp
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-315">
                  User & Role
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-316">
                  Action
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-317">
                  Item ID
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-318">
                  Details
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-slate-200" data-id="element-319">
              {filteredLogs.map(log => <tr key={log.id} className="hover:bg-slate-50" data-id="element-320">
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-500" data-id="element-321">
                    {new Date(log.timestamp).toLocaleString()}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-322">
                    <div className="text-sm font-medium text-slate-900" data-id="element-323">
                      {log.user}
                    </div>
                    <div className="text-xs text-slate-500 uppercase tracking-wide" data-id="element-324">
                      {log.role}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-325">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium
                      ${log.action.includes('Approve') || log.action.includes('Publish') ? 'bg-teal-100 text-teal-800' : log.action.includes('Reject') ? 'bg-red-100 text-red-800' : log.action.includes('Upload') ? 'bg-blue-100 text-blue-800' : 'bg-slate-100 text-slate-800'}`} data-id="element-326">
                      {log.action}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-slate-900" data-id="element-327">
                    {log.item}
                  </td>
                  <td className="px-6 py-4 text-sm text-slate-600 max-w-md" data-id="element-328">
                    {log.statusChange && <div className="text-xs font-semibold text-slate-800 mb-1" data-id="element-329">
                        {log.statusChange}
                      </div>}
                    <div className="truncate" title={log.details} data-id="element-330">
                      {log.details}
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
};